// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "index" + "." + "fb9ffb527b5f2e1f2587" + ".css";
};